import { withRouter } from "react-router-dom";
import { withAuth } from "shared-auth";
import { withGlobalContextProvider } from "shared/contexts/GlobalContext";

import compose from "shared/utils/compose";
import { withChangesTracker } from "contexts/ChangesTrackingContext";
import { withFlowContextProvider } from "contexts/FlowContext";

import { withTranslation as withTranslationConsumer } from "./contexts/TranslationContext";
import withAnonymousAccess from "./hoc/withAnonymousAccess";
import withErrorCatcher from "./hoc/withErrorCatcher";
import withGlobalLoader from "./hoc/withGlobalLoader";
import withIdentification from "./hoc/withIdentification";
import withPageData from "./hoc/withPageData";
import withQueryActionHandling from "./hoc/withQueryActionHandling";
import withTranslation from "./hoc/withTranslation";
import withUserInfo from "./hoc/withUserInfo";

import MasterPage from "./MasterPage/MasterPage";
import "./App.scss";
import withArtistRef from "app/hoc/withArtistRef";

export const App = () => <MasterPage />;

export default compose(
  withAuth,
  withChangesTracker,
  withRouter,
  withGlobalContextProvider,
  withGlobalLoader,
  withTranslation,
  withTranslationConsumer,
  withErrorCatcher,
  withArtistRef,
  withAnonymousAccess,
  withIdentification,
  withUserInfo,
  withFlowContextProvider,
  withPageData,
  withQueryActionHandling
)(App);
